const ONE_DAY_MS = 86400000

// The API's date filters (API Platform DateFilter) compare against a date-only value as
// midnight UTC, so `startDate[before]=2026-10-31` means "starts at or before Oct 31 00:00 UTC".
// Truncating a local range end (e.g. Oct 31 23:59:59 local) to its UTC date therefore cuts off
// the range's last day for any viewer at or east of UTC (UK, Europe, Asia, Australia), hiding
// tactics/initiatives that start on it. All-day items are additionally keyed to the calendar date
// of their stored UTC instant (see parseAllDayDate), not the viewer's local day.
//
// Pad each bound by one day so the query always covers the full local range in every timezone.
// Over-fetching is harmless: views only render or list items within their own date range.

// Value for `startDate[before]` covering every item that starts on or before the given range end
export function getApiRangeEndBound(rangeEnd: Date): string {
  return new Date(rangeEnd.getTime() + ONE_DAY_MS).toISOString().split('T')[0]
}

// Value for `endDate[after]` covering every item that ends on or after the given range start
export function getApiRangeStartBound(rangeStart: Date): string {
  return new Date(rangeStart.getTime() - ONE_DAY_MS).toISOString().split('T')[0]
}
